<template>
  <v-content :style="`background:url(${background}); background-size:cover; height:100vh`">
    <app-alert @dismissed="onDismissed" :text="error" v-if="error"></app-alert>
    <v-container>
      <template>
        <sign-in-dialog/>
        <sign-up-dialog :showSignUpDialog="showSignUpDialog"/>
      </template>
      <v-row class="text-center">
        <v-col cols="12">
          <v-img
            src="https://firebasestorage.googleapis.com/v0/b/adariz-cms.appspot.com/o/Adariz%2FADARIZ-logo-4-900x200.png?alt=media&token=bfc61827-2f85-4061-b06f-41b2acc46fd7"
            class="my-3 mb-5"
            contain
            height="100"
          ></v-img>
        </v-col>
        <v-row v-if="onLoading">
          <v-col class="text-center" cols="12">
            <loading-circular/>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col class="mb-4" style="color:#fff" v-if="userIsAuthenticated">
            <h1 class="display-2 font-weight-bold mb-5">
              Hola {{user.firstName}}
            </h1>
            <v-row>
              <v-col>
                <h1 class="display-2 mb-3" v-if="companyData.companyStatus === 'active' && user.role === 'administrator'">
                  Bienvenido a Adariz <br>Experto Virtual en Ventas
                </h1>
                <h4 v-else-if="companyData.companyStatus === 'inactive'" style="color:red">
                  Lo siento pero tu cuenta está inactiva porque no realizaste el pago del mes siguiente. <br> Si quieres seguir usando nuestros servicios ponte en contacto con nosotros.
                </h4>
                <h3 v-if="user.role === 'editor' && user.companyId === ''">Por favor envía tu ID al administrador de la cuenta.</h3>
                <h3 v-else-if="user.role === 'editor' && user.companyId !== ''">Colaborando con {{user.companyName}}</h3>
                <h3 v-if="user.role === 'editor'">ID: {{user.id}}</h3>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            v-else
            cols="4"
            offset="4"
            class="pb-0 pt-7"
            style="background:rgba(0, 0, 0, 0.72);border-radius: 10px;color:#e2e2e2"
          >
            <h1 class="display-1">
              Por favor inicia sesión <br>para poder empezar
            </h1>
            <v-row>
              <v-col cols="12" class="mb-2 mt-4">
                <p>Continuar como usuario</p>
                <v-row>
                  <v-col class="pt-0">
                    <v-btn
                      onlogin="checkLoginState()"
                      color="#1877F2"
                      dark
                      rounded
                      small
                      width="200"
                      elevation="10"
                      @click="onSignInFacebook"
                    >
                      Iniciar con Facebook
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <p class="body-2">Continuar como<br>colaborador</p>
                <v-row>
                  <v-col cols="12" class="pt-0">
                    <v-btn
                      color="#000"
                      dark
                      rounded
                      x-small
                      elevation="10"
                      @click="onSignInEmail"
                    >
                      Iniciar con email
                    </v-btn>
                  </v-col>
                  <v-col cols="12" class="pt-0">
                    <v-btn
                      @click="onSignUpEmail"
                      x-small
                      dark
                      text
                    >Crear cuenta colaborador</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
/* eslint-disable no-console */
import * as constants from '../../constants.json'

export default {
  data () {
    return {
      companyId: '',
      companyName: '',
      companyStatus: '',
      showSignInDialog: { show: false },
      showSignUpDialog: { show: false },
      background: constants.BACKGROUND
    }
  },

  mounted () {
    const facebookJsSdk = document.createElement('script')
    facebookJsSdk.src = '/js/facebook-jssdk.js'
    facebookJsSdk.async = true
    facebookJsSdk.defer = true
    facebookJsSdk.crossOrigin = 'anonymous'
    document.head.appendChild(facebookJsSdk)
  },

  created () {
    this.$store.dispatch('actionSetToolbar', false)
  },

  computed: {
    userIsAuthenticated () {
      return this.$store.getters.getUser !== null && this.$store.getters.getUser !== undefined
    },

    user () {
      return this.$store.getters.getUser
    },

    companyData () {
      return {
        companyId: this.$store.getters.getCompanyData.companyId,
        companyName: this.$store.getters.getCompanyData.companyName,
        companyStatus: this.$store.getters.getCompanyData.companyStatus
      }
    },

    onLoading () {
      return this.$store.getters.getLoading
    },

    error () {
      return this.$store.getters.getError
    }
  },
  methods: {
    async onSignInFacebook () {
      try {
        window.FB.Event.subscribe('auth.authResponseChange', this.checkLoginState)

        window.FB.login(function (response) {
          // handle the response
        }, { scope: 'public_profile,email,pages_messaging,pages_show_list,user_gender' })
      } catch (error) {
        alert(error)
      }
    },

    checkLoginState (event) {
      console.log('logged in', event)
      let profile = ''
      window.FB.api('/me', { fields: 'name,first_name,last_name,email,picture.width(150).height(150)' }, (response) => {
        profile = {
          name: response.name,
          firstName: response.first_name,
          lastName: response.last_name,
          email: response.email,
          photoUrl: response.picture.data.url
        }
        this.$store.dispatch('actionFacebookLogin', { event, profile })
      })
    },

    async onSignInEmail () {
      this.$store.commit('mutationOpenSignInDialog', true)
    },

    async onSignUpEmail () {
      this.$store.commit('mutationOpenSignUpDialog', true)
    },

    onDismissed () {
      // eslint-disable-next-line
      console.log('Dismissed Alert')
      this.$store.dispatch('actionClearError')
    }
  }
}
</script>
